<template>
  <v-card>
    <v-card-title>
      <h3 class="mt-2 mb-2">Client data</h3>
    </v-card-title>
    <v-divider></v-divider>
    <v-list>
      <v-list-tile ripple>
        <v-flex xs4 md2>
          <h5><b>Name</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          {{ caseModel.client ? caseModel.client.name : 'N/A' }}
        </v-flex>
      </v-list-tile>
    </v-list>

    <v-divider></v-divider>
    <v-card-title>
      <h3>Client Agreement And Invoice</h3>
      <v-spacer></v-spacer>
      <v-tooltip
        left
        v-if="$can('view', 'cases-detail-actions-tab') && caseInvoices && caseInvoices.length">
        <v-btn icon slot="activator">
          <v-icon
            :color="'green'"
            block
            @click.native="markPaid"
            :loading="loading.paidInvoiceBtn"
            :disabled="markPaidDisabled"
          >done</v-icon>
        </v-btn>
        <span>Mark Invoice Paid</span>
      </v-tooltip>
    </v-card-title>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-tile>
        <v-list-tile-content>
          <b>Agreement</b>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn @click="downloadAgreement" :loading="loadingAgreement" :disabled="!caseModel.answers.length" outline color="blue">PDF
            <v-icon>list</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <b>Latest {{ (caseModel.status === 'closed') ? 'Invoice' : 'Quotation'}}
            <span v-if="caseInvoices.length">({{ caseInvoices[caseInvoices.length -1].status }})</span></b>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn @click="downloadInvoice" :loading="loadingInvoice" :disabled="disabled.invoice" outline color="blue">PDF
            <v-icon>list</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <v-data-table
      :headers="tableHeaders"
      :items="items"
      hide-actions
      no-data-text="No invoices."
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>
          <v-btn
            flat
            depressed
            small
            left
            :href="props.item.invoice_path"
            target="_blank"
          >{{ (caseModel.status === 'closed') && (props.item.id === items[items.length - 1].id) ? 'view invoice' : 'view quotation'}}</v-btn>
        </td>
        <td>{{ props.item.status ? props.item.status : 'pending' }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>
          <v-tooltip top>
            <v-btn slot="activator" icon class="mx-0" v-if="$can('mark-paid', 'invoices') && props.item.status === 'pending'" @click="markPaidInvoice(props.item.id)">
              <v-icon color="teal">done</v-icon>
            </v-btn>
            Mark paid
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false" rawHtml></AppMainDialog>
  </v-card>
</template>

<script>
  import AppMainDialog from '@/components/AppMainDialog'
  import invoicesAPI from '@/api/invoice'
  import { mapGetters } from 'vuex'
  // import _ from 'lodash'

  export default {
    components: { AppMainDialog },
    data () {
      return {
        tableHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Invoice path', value: 'invoice_path' },
          { text: 'Status', value: 'status' },
          { text: 'Created Date', value: 'created_at' },
          { text: 'Actions', value: 'actions' }
        ],
        clientData: {},
        dialogOpen: false,
        dialogMessage: '',
        loadingInvoice: false,
        loadingAgreement: false,
        loading: {
          paidInvoiceBtn: false
        },
        disabled: {
          agreement: true,
          invoice: true
        },
        markPaidDisabled: false
      }
    },
    computed: {
      ...mapGetters({
        clientById: 'getClientById',
        caseById: 'getCaseById',
        getAllCases: 'getAllCases',
        caseInvoices: 'currentCaseInvoices',
        getLastOnBoardForm: 'getLastOnBoardForm',
        items: 'currentCaseInvoices'
      })
    },
    props: {
      caseModel: {
        type: Object,
        required: true
      }
    },
    watch: {
      caseModel (m) {
        this.$store.dispatch('getCaseInvoices', m.id)
      },
      caseInvoices (c) {
        if (c && c.length) this.disabled.invoice = false
      }
    },
    methods: {
      markPaidInvoice (itemId) {
        invoicesAPI.markPaid(itemId).then(() => {
          this.loadLinkedInvoices()
        }, () => {})
      },
      loadLinkedInvoices () {
        this.$store.dispatch('getCaseInvoices', this.caseModel.id)
      },
      downloadAgreement () {
        this.loadingAgreement = true
        this.$store.dispatch('loadPdfAgreement', this.getLastOnBoardForm.id).then(result => {
          this.loadingAgreement = false

          this.dialogMessage = '<a href="' + result.aws_s3_url + '" target="_blank">' + result.aws_s3_url + '</a>'
          this.dialogOpen = true
        })
      },
      downloadInvoice () {
        this.loadingInvoice = true

        if (this.caseInvoices.length) {
          let path = this.caseInvoices[this.caseInvoices.length - 1].invoice_path
          this.loadingInvoice = false
          this.dialogMessage = '<a href="' + path + '" target="_blank">' + path + '</a>'
          this.dialogOpen = true
        }
        // window.open(window.location.origin + '/', '_blank')
      },
      markPaid () {
        this.loading.paidInvoiceBtn = true
        this.$store.dispatch('markInvoiceAsPaid', this.caseModel.id).then(() => {
          this.loading.paidInvoiceBtn = false
          this.markPaidDisabled = true
        })
      }
    },
    created () {
      this.$store.dispatch('getCaseInvoices', this.caseModel.id)
    }
  }
</script>



// WEBPACK FOOTER //
// CaseClientDataTable.vue?083d6e10